import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function ClubLectura() {
    useMeta({
        title: 'Club de Lectura - MiMadre Universe',
        description: 'Club de lectura dirigido por Inmaculada Fuentes. Espacio de encuentro para compartir la pasión por los libros y la literatura.',
        image: '/portada_mimadre.avif',
        url: 'https://inmaculadafuentes.com/club-lectura'
    });

    return (
        <div className="app">
            <Navbar showHomeLink />

            <section className="book-page">
                <div className="book-hero">
                    <h1>Club de Lectura</h1>
                    <p>Espacio de encuentro para compartir la pasión por los libros</p>
                </div>

                <div className="book-section">
                    <h2>Próximamente</h2>
                    <p>Esta sección estará disponible próximamente con información sobre nuestro club de lectura.</p>
                </div>
            </section>
        </div>
    );
}

export default ClubLectura;